$(function() {
    $('[data-delay]').each(function() {
        init(this);
    });

    function init(el) {
        $(el).click(function(e) {
            e.preventDefault();
            var link = $(this).attr("href");
            setTimeout(function() {
                window.location.href = link;
            }, 5000);
        });
    }
});